<organism-modal
    [modalTitle]="TITLE_ADD_DOC_REQUIREMENT | translateTokenisedString"
>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div
            class="form-action-buttons px-4 py-2 active-component d-flex align-items-center"
        >
            <div class="ms-auto d-flex align-items-center">
                <button
                    class="btn btn-outline-primary"
                    type="button"
                    (click)="onCancel()"
                >
                    {{ CANCEL_BTN | translateTokenisedString }}
                </button>

                <atom-async-button
                    [isLoading]="isSaving$ | ngrxPush"
                    btnClass="btn btn-primary ms-2"
                    data-cy="btn-add-document-requirement"
                    >{{ ADD_BTN | translateTokenisedString }}
                </atom-async-button>
            </div>
        </div>
        <atom-async-data
            class="w-100"
            [isLoading]="isSaving$ | ngrxPush"
            [overlayContent]="true"
        >
            <div class="py-4 px-4 input form-input">
                <wdx-form-field
                    class="d-block mb-5"
                    [legend]="
                        LEGEND_SELECT_DOC_REQUIREMENT | translateTokenisedString
                    "
                    [isRequired]="true"
                    labelForId="documentRequirement"
                    [validationErrorMessage]="
                        documentRequirementControl?.touched &&
                            documentRequirementControl?.errors
                            | validationErrorMessage
                    "
                >
                    <ng-select
                        [placeholder]="
                            PLACEHOLDER_SELECT | translateTokenisedString
                        "
                        formControlName="documentRequirement"
                        labelForId="documentRequirement"
                        data-cy="dropdown-documentRequirement"
                    >
                        @for (
                            item of documentRequirementTypes$ | ngrxPush;
                            track $index
                        ) {
                            <ng-option
                                [value]="{
                                    id: item.id,
                                    code: item.code,
                                    type: item.targetEntityType,
                                    name: item.name,
                                }"
                            >
                                {{ item.name }}
                            </ng-option>
                        }
                    </ng-select>
                </wdx-form-field>

                @if (displayRelatedPartyControl) {
                    <div class="mb-5">
                        <wdx-form-field
                            class="d-block"
                            [legend]="
                                (secondarySelect$ | ngrxPush)?.label
                                    | translateTokenisedString
                            "
                            [isRequired]="true"
                            labelForId="relatedParty"
                        >
                            <ng-select
                                bindLabel="name"
                                bindValue="id"
                                formControlName="relatedParty"
                                labelForId="relatedParty"
                                [placeholder]="
                                    (secondarySelect$ | ngrxPush)?.label
                                        | translateTokenisedString
                                "
                                [items]="relatedParty$ | ngrxPush"
                                [loading]="relatedPartyIsLoading$ | ngrxPush"
                                [notFoundText]="
                                    'DROPDOWN_NO_ITEMS'
                                        | translateTokenisedString
                                "
                                data-cy="dropdown-relatedParty"
                            >
                            </ng-select>
                        </wdx-form-field>
                        @if (
                            noRecordsForType$
                                | ngrxPush
                                | translateTokenisedString;
                            as noRecordsForType
                        ) {
                            <p class="text-danger">
                                {{
                                    NO_RECORD_ASSOCIATED
                                        | translateTokenisedString
                                            : {
                                                  noRecordsForType,
                                              }
                                }}
                            </p>
                        }
                    </div>
                }
            </div>
        </atom-async-data>
    </form>
</organism-modal>
